import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Select Icon
 *
 * @file Select.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Select = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 17 18" {...props}>
    <g fill="none">
      <path
        d="M8.49267 1.43579L7.15 1.43579C4.90979 1.43579 3.78968 1.43579 2.93404
          1.87176C2.18139 2.25526 1.56947 2.86718 1.18597 3.61983C0.75 4.47548 0.75
          5.59558 0.75 7.83579L0.75 10.5211C0.75 12.7613 0.75 13.8815 1.18597 14.7371C1.56947
          15.4897 2.18139 16.1017 2.93404 16.4852C3.78968 16.9211 4.90979 16.9211 7.15
          16.9211H9.83535C12.0756 16.9211 13.1957 16.9211 14.0513 16.4852C14.804
          16.1017 15.4159 15.4897 15.7994 14.7371C16.2353 13.8815 16.2353 12.7613
          16.2353 10.5211V9.17846"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.91187 11.9588L5.08833 8.95592C4.79124 8.63997 4.8063 8.14278 5.12195
          7.84541C5.4376 7.54805 5.93432 7.56311 6.23141 7.87906L8.40501 10.1907L14.4456
          1.55318C14.6941 1.19773 15.1835 1.11128 15.5387 1.3601C15.8938 1.60891
          15.9801 2.09876 15.7315 2.45421L9.1377 11.8829C8.88912 12.2383 8.39973
          12.3248 8.04462 12.0759C7.99508 12.0412 7.95077 12.0018 7.91187 11.9588Z"
        fill="currentcolor"
      />
    </g>
  </SvgIcon>
);

export default Select;
